import React, { useEffect, useState } from "react";
import { FiCheck, FiChevronDown } from "react-icons/fi";
import { useCurrencyDisplay } from "./CurrencyDisplayContext";

export default function CurrencyQuickSelector({ expanded = false, label = "Display currency" }) {
  const [open, setOpen] = useState(false);
  const {
    enabled,
    loading,
    currencies,
    displayCurrency,
    baseCurrency,
    setDisplayCurrency,
  } = useCurrencyDisplay();

  useEffect(() => {
    if (!expanded) setOpen(false);
  }, [expanded]);

  if (!enabled || currencies.length < 2) return null;

  return (
    <div className={`pmsCurrencyControl ${open ? "pmsCurrencyControl--open" : ""}`}>
      <button
        type="button"
        className="pmsCurrencyControl__trigger"
        onClick={() => expanded && setOpen((current) => !current)}
        disabled={loading}
        aria-expanded={expanded ? open : false}
        aria-label={`${label}: ${displayCurrency}`}
        title={`${label}: ${displayCurrency}. Base: ${baseCurrency}.`}
      >
        <span className="pmsCurrencyControl__code">{displayCurrency}</span>
        <span className="pmsCurrencyControl__text">
          <span>{label}</span>
        </span>
        <span className="pmsCurrencyControl__chevron" aria-hidden="true">
          <FiChevronDown size={14} />
        </span>
      </button>

      {expanded && open ? (
        <div className="pmsCurrencyControl__options" role="listbox" aria-label={label}>
          {currencies.map((code) => {
            const selected = code === displayCurrency;
            return (
              <button
                key={code}
                type="button"
                className={`pmsCurrencyControl__option ${
                  selected ? "pmsCurrencyControl__option--active" : ""
                }`}
                onClick={() => {
                  setDisplayCurrency(code);
                  setOpen(false);
                }}
                role="option"
                aria-selected={selected}
              >
                <span>{code}</span>
                {selected ? <FiCheck size={13} aria-hidden="true" /> : null}
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
